import React, { useRef } from 'react';
import useClickOutside from 'hooks/useClickOutside';

function ClickOutside({ children, onClickOutside, className }) {
  const ref = useRef(null);
  useClickOutside(ref, () => onClickOutside());

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}

export default ClickOutside;
